import { CATEGORIES_TOOLS } from '../../RiskFactorCategories/constants';
import { useGetRiskFactorCategories } from '../../RiskFactorCategories/hooks/useGetRiskFactorCategories';
import { useResolution886Report } from '@/context/Resolution886Report';

function findRiskDataByCategory(tasks: any[], category_key: string) {
	return tasks
		?.find((task) => task.categories?.find((category: { key: string }) => category.key === category_key))
		?.categories?.find((category: { key: string }) => category.key === category_key);
}

export const useGetEvaluationTools = (category_key: string) => {
	const { report } = useResolution886Report();
	const { tasks } = useGetRiskFactorCategories(report, category_key);

	const toolConfig = CATEGORIES_TOOLS.find((tool) => tool.category_key === category_key);
	const riskData = findRiskDataByCategory(tasks, category_key);

	return {
		tools: {
			...toolConfig,
			risk: riskData?.toolRisk || null
		}
	};
};
